import React, {useState, useEffect} from "react";
import tw from "twin.macro";

import {Container} from "components/misc/Layouts";
import {SectionHeading} from "components/misc/Headings";
import Footer from "components/Footer";
import Hero from "components/headers/light";
import MovieCard from "components/MovieCard";
import ReadMoreButton from "components/ReadMoreButton";
import {useAppDispatch, loadMovie, loadMoreMovie, useAppSelector} from "../../redux";
import AdComponent from '../../components/AdComponent.js';
const Heading = tw.text`text-2xl font-bold  text-gray-900`;
const ContentWithPaddingXl = tw.div`max-w-screen-xl min-h-screen xsm:px-2 w-full mx-auto pt-24`;
const One = tw.div`max-w-screen-xl grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-3 lg:grid-cols-6 lg:gap-4 xsm:mt-10 lg:mx-2 lg:mt-2 px-1`;

const Root = tw.div`lg:flex lg:mt-0 xsm:-mt-8`;
const Div = tw.div`w-full mx-auto px-5 xsm:py-2 lg:py-4 z-50 fixed bg-white`;
const Hr = tw.hr`mt-2`;

export default ({headingText = "Movies"}) => {
  const dispatch = useAppDispatch();
  const movie = useAppSelector(state => state.movie.movie);
  const isEndReached = useAppSelector(state => state.movie.isEndReached);
  const [footerShow, setFooterShow] = useState("");

  useEffect(() => {
    if (movie.length <= 0) {
      dispatch(loadMovie());
    }
  }, [dispatch]);

  const handleLoadMoreData = () => {
    dispatch(loadMoreMovie());
  };

  return (
    <>
      <Div>
        <Hero />
        <Hr />
      </Div>
      <Container>
        <AdComponent />
        <ContentWithPaddingXl>
          <Heading>{headingText}</Heading>
          <Root>
            <One>
              <MovieCard movie={movie} />
            </One>
          </Root>
          {isEndReached ? null : <ReadMoreButton handleLoadMoreData={handleLoadMoreData} />}
        </ContentWithPaddingXl>
      </Container>

      {footerShow ? <Footer /> : <></>}

    </>
  );
};
